import { render, staticRenderFns } from "./faceIsSuccess.vue?vue&type=template&id=f9137b32&scoped=true&"
import script from "./faceIsSuccess.vue?vue&type=script&lang=js&"
export * from "./faceIsSuccess.vue?vue&type=script&lang=js&"
import style0 from "./faceIsSuccess.vue?vue&type=style&index=0&id=f9137b32&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9137b32",
  null
  
)

export default component.exports